import { Stack, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { ContactTableAiFieldFlag } from "./ContactTableAiFieldFlag";
import type { RealEstateContact } from "../../../../../@types/sharedSchema";

type ContactTableRoomsProps = {
  contact: RealEstateContact;
};

export function ContactTableRooms({ contact }: ContactTableRoomsProps): JSX.Element {
  const { t: translate } = useTranslation();

  const { roomsMin, roomsMax } = contact;

  const roomsMinExists = typeof roomsMin === "number";
  const roomsMaxExists = typeof roomsMax === "number";

  const eitherRoomExists = roomsMinExists || roomsMaxExists;

  if (!eitherRoomExists) return null;

  const bothRoomExists = roomsMinExists && roomsMaxExists;

  return (
    <Grid item order={0} xs={6} md={4}>
      <Stack gap={0.5}>
        <Typography variant="subtitle2">{translate("contactsPage.tableColumns.rooms")}</Typography>
        <Stack gap={1} direction="row" alignItems="center">
          {roomsMinExists && (
            <ContactTableAiFieldFlag id="roomsMin" contact={contact}>
              <Typography variant="body2">{roomsMin}</Typography>
            </ContactTableAiFieldFlag>
          )}
          {bothRoomExists && <span>-</span>}
          {roomsMaxExists && (
            <ContactTableAiFieldFlag id="roomsMax" contact={contact}>
              <Typography variant="body2">{roomsMax}</Typography>
            </ContactTableAiFieldFlag>
          )}
        </Stack>
      </Stack>
    </Grid>
  );
}
